export default "__VITE_ASSET__$m0FVlzF__"